module.exports = __webpack_public_path__ + "img/max2.c943dd24.jpg";